import { defineStore } from 'pinia'
import { ref } from 'vue'

export type ActionOverlayMode = 'success' | 'delete' | 'sync'

/**
 * Full-screen action feedback (PCG-style sync / success animations).
 */
export const useActionOverlayStore = defineStore('actionOverlay', () => {
  const isVisible = ref(false)
  const mode = ref<ActionOverlayMode>('sync')
  const title = ref('')
  const message = ref('')

  function showLoading(overlayTitle: string, overlayMessage: string): void {
    mode.value = 'sync'
    title.value = overlayTitle
    message.value = overlayMessage
    isVisible.value = true
  }

  function hide(): void {
    isVisible.value = false
  }

  /**
   * Switches to success animation, then hides after `durationMs`.
   */
  function showSuccess(overlayTitle: string, overlayMessage: string, durationMs = 2200): Promise<void> {
    mode.value = 'success'
    title.value = overlayTitle
    message.value = overlayMessage
    isVisible.value = true
    return new Promise((resolve) => {
      setTimeout(() => {
        isVisible.value = false
        resolve()
      }, durationMs)
    })
  }

  return {
    isVisible,
    mode,
    title,
    message,
    showLoading,
    hide,
    showSuccess,
  }
})
